<template>
    <div class="card-container ele-two-fix">
        <Row class=" limit-line table-row-odd" type="flex">
            <Col flex="1">
            </Col>
            <Col flex="1" class="desc-field">{{ getTranslation('k218') }}
            </Col>
            <Col flex="1" class="desc-field">{{ getTranslation('k197') }}
            </Col>
            <Col flex="1" class="desc-field">{{ getTranslation('k198') }}
            </Col>
            <Col flex="1">
            </Col>
            <Col flex="1" class="desc-field">{{ getTranslation('k099') }}
            </Col>
            <Col flex="1" class="desc-field">{{ getTranslation('k181') }}
            </Col>
            <Col flex="1" class="desc-field">{{ getTranslation('k219') }}
            </Col>
        </Row>
        <Row class=" limit-line menu-actions" type="flex">
            <Col flex="1" class="desc-field">{{ getTranslation('k199') }}
            </Col>
            <Col flex="1"><Input type="number" class="input-field" v-model="info.ValGun2StepIncNumSet" />
            </Col>
            <Col flex="1"><Input type="text" class="input-field" v-model="info.ValGun2StepIncNumCnt" disabled />
            </Col>
            <Col flex="1" class="desc-field"><Button type="info" size="small" icon="md-close"
                @click.native="clearVal('ValGun2StepIncNumCnt')">{{ getTranslation('k198')
                }}</Button>
            </Col>
            <Col flex="1" class="desc-field"><template v-if="info && info.ValGun2StepIncNumSet>0">{{ getTranslation('k204') }}</template>
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>0"  type="text" class="input-field" v-model="info.NumGun2SpotCompensation1" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>0)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>0" type="text" class="input-field" v-model="info.CofGun2PowerCompensation1" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>0)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>0" type="text" class="input-field" v-model="info.CofGun2PressCompensation1" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>0)" />
            </Col>
        </Row>
        <Row class=" limit-line table-row-odd menu-actions" type="flex">
            <Col flex="1" class="desc-field">{{ getTranslation('k200') }}
            </Col>
            <Col flex="1"><Input type="number" class="input-field" v-model="info.ValGun2DressedNumSet" />
            </Col>
            <Col flex="1"><Input type="text" class="input-field" v-model="info.ValGun2DressedNumCnt" disabled />
            </Col>
            <Col flex="1" class="desc-field"><Button type="info" size="small" icon="md-close"
                @click.native="clearVal('ValGun2DressedNumCnt')">{{ getTranslation('k198')
                }}</Button>
            </Col>
            <Col flex="1" class="desc-field"><template v-if="info && info.ValGun2StepIncNumSet>1">{{ getTranslation('k205') }}</template><template v-else-if="info && info.ValGun2StepIncNumSet==1">{{ getTranslation('s335') }}</template><template v-else></template>
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>0" type="text" class="input-field" v-model="info.NumGun2SpotCompensation2" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>0)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>1" type="text" class="input-field" v-model="info.CofGun2PowerCompensation2" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>1)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>1" type="text" class="input-field" v-model="info.CofGun2PressCompensation2" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>1)" />
            </Col>
        </Row>
        <Row class=" limit-line" type="flex">
            <Col flex="1" class="desc-field">{{ getTranslation('k201') }}
            </Col>
            <Col flex="1"><Input type="number" class="input-field" v-model="info.ValGun2DressedPreWarnSet" />
            </Col>
            <Col flex="2">
            </Col>
            <Col flex="1" class="desc-field"><template v-if="info && info.ValGun2StepIncNumSet>2">{{ getTranslation('k206') }}</template><template v-else-if="info && info.ValGun2StepIncNumSet==2">{{ getTranslation('s335') }}</template><template v-else></template> 
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>1" type="text" class="input-field" v-model="info.NumGun2SpotCompensation3" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>1)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>2" type="text" class="input-field" v-model="info.CofGun2PowerCompensation3" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>2)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>2" type="text" class="input-field" v-model="info.CofGun2PressCompensation3" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>2)" />
            </Col>
        </Row>

        <Row class=" limit-line table-row-odd" type="flex">
            <Col flex="1" class="desc-field">{{ getTranslation('k202') }}
            </Col>
            <Col flex="1"><Input type="number" class="input-field" v-model="info.PssGun2RepairElectrodeUp" />
            </Col>
            <Col flex="2">
            </Col>
            <Col flex="1" class="desc-field"><template v-if="info && info.ValGun2StepIncNumSet>3">{{ getTranslation('k207') }}</template><template v-else-if="info && info.ValGun2StepIncNumSet==3">{{ getTranslation('s335') }}</template><template v-else></template>
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>2" type="text" class="input-field" v-model="info.NumGun2SpotCompensation4" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>2)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>3" type="text" class="input-field" v-model="info.CofGun2PowerCompensation4" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>3)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>3" type="text" class="input-field" v-model="info.CofGun2PressCompensation4" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>3)" />
            </Col>
        </Row>
        <Row class=" limit-line" type="flex">
            <Col flex="1" class="desc-field">{{ getTranslation('k203') }}
            </Col>
            <Col flex="1"><Input type="number" class="input-field" v-model="info.PssGun2RepairElectrode" />
            </Col>
            <Col flex="2">
            </Col>
            <Col flex="1" class="desc-field"><template v-if="info && info.ValGun2StepIncNumSet>4">{{ getTranslation('k208') }}</template><template v-else-if="info && info.ValGun2StepIncNumSet==4">{{ getTranslation('s335') }}</template><template v-else></template>
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>3" type="text" class="input-field" v-model="info.NumGun2SpotCompensation5" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>3)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>4" type="text" class="input-field" v-model="info.CofGun2PowerCompensation5" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>4)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>4" type="text" class="input-field" v-model="info.CofGun2PressCompensation5" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>4)" />
            </Col>
        </Row>
        <Row class=" limit-line table-row-odd" type="flex">
            <Col flex="1" class="desc-field">{{ getTranslation('k180') }}
            </Col>
            <Col flex="1"><Select :transfer="true" class="input-field" :placeholder="getTranslation('m034')"
                v-model="info.OptStepCompFunc" :not-found-text="getTranslation('b038')">
                <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
            </Select>
            </Col>
            <Col flex="2">
            </Col>
            <Col flex="1" class="desc-field"><template v-if="info && info.ValGun2StepIncNumSet>5">{{ getTranslation('k209') }}</template><template v-else-if="info && info.ValGun2StepIncNumSet==5">{{ getTranslation('s335') }}</template><template v-else></template>
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>4" type="text" class="input-field" v-model="info.NumGun2SpotCompensation6" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>4)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>5" type="text" class="input-field" v-model="info.CofGun2PowerCompensation6" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>5)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>5" type="text" class="input-field" v-model="info.CofGun2PressCompensation6" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>5)" />
            </Col>
        </Row>

        <Row class=" limit-line" type="flex">
            <Col flex="4">
            </Col>
            <Col flex="1" class="desc-field"><template v-if="info && info.ValGun2StepIncNumSet>6">{{ getTranslation('k210') }}</template><template v-else-if="info && info.ValGun2StepIncNumSet==6">{{ getTranslation('s335') }}</template><template v-else></template>
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>5" type="text" class="input-field" v-model="info.NumGun2SpotCompensation7" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>5)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>6" type="text" class="input-field" v-model="info.CofGun2PowerCompensation7" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>6)" />
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>6" type="text" class="input-field" v-model="info.CofGun2PressCompensation7" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>6)" />
            </Col>
        </Row>
        <Row class=" limit-line" type="flex">
            <Col flex="4">
            </Col>
            <Col flex="1" class="desc-field table-row-odd"><template v-if="info && info.ValGun2StepIncNumSet>7">{{ getTranslation('k211') }}</template><template v-else-if="info && info.ValGun2StepIncNumSet==7">{{ getTranslation('s335') }}</template><template v-else></template>   
            </Col>
            <Col flex="1" class="table-row-odd"><Input v-if="info && info.ValGun2StepIncNumSet>6" type="text" class="input-field" v-model="info.NumGun2SpotCompensation8" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>6)" />
            </Col>
            <Col flex="1" class="table-row-odd"><Input v-if="info && info.ValGun2StepIncNumSet>7" type="text" class="input-field" v-model="info.CofGun2PowerCompensation8" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>7)" />
            </Col>
            <Col flex="1" class="table-row-odd"><Input v-if="info && info.ValGun2StepIncNumSet>7" type="text" class="input-field" v-model="info.CofGun2PressCompensation8" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>7)" />
            </Col>
        </Row>
        <Row class=" limit-line" type="flex">
            <Col flex="4">
            </Col>
            <Col flex="1" class="desc-field"><template v-if="info && info.ValGun2StepIncNumSet>=8">{{ getTranslation('s335') }}</template>
            </Col>
            <Col flex="1"><Input v-if="info && info.ValGun2StepIncNumSet>7" type="text" class="input-field" v-model="info.NumGun2SpotCompensation9" :disabled="!(info && info.OptStepCompFunc && info.OptStepCompFunc ==1 && info.ValGun2StepIncNumSet>7)" />
            </Col>
            <Col flex="1">
            </Col>
            <Col flex="1">
            </Col>
        </Row>

        <Row class="menu-actions">
            <Col>
            <Button :type="downloadType" size="small" icon="md-download" @click.native="downloadFixOne()">{{ getTranslation('k023')
            }}</Button>
            </Col>
        </Row>
    </div>
</template>
<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { Row, Col, Button, Input, Select, Option, } from "view-design"
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
    name: 'ElectrodeCount', // 组件名称
    components: {
        Row, Col, Button, Input, Select, Option,
    },
    props: {
    },
    data() {
        return {
            info: {},
            mac: 0,
            downloadType: 'primary',
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        SwitchList() {
            return [
                this.getTranslation("k048"),
                this.getTranslation("k049"),
            ]
        },

    },
    watch: {

    },

    created() {
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac
            this.getInfo();
        },
        getInfo() {
            let url = API_URL["productionElectrodeTwoFix"];
            if (!this.mac) {
                this.$Message.error(this.getTranslation('m041'));
                return
            }
            let params = {
                mac: this.mac
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.info = res.data.data;
                        //this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        downloadFixOne() {
            let url = API_URL["ProductionFixTwoDownload"] + '?mac=' + this.mac
            let params = new FormData();
            this.info && Object.keys(this.info).forEach(key => {
                params.append(key, this.info[key]);
            });
            axios.post(url,
                params
            )
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                        this.downloadType = 'primary'
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        clearVal(val) {
            this.$set(this.info, val, 0)
            this.$Message.warning(this.getTranslation('b192'))
            this.downloadType = 'error'
        }
    },

}
</script>
<style scoped>
@import url('../../../assets/style/list.css');
/* 针对 disabled Input 组件的样式 */
::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
  color: #999 !important;
  background-color: #f8f9fa !important;
  border-color: #ced4da !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #999 !important;
}
.ele-two-fix{
    margin-left:4px !important;
}
</style>